export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-[24px] overflow-hidden mb-10 md:mb-14 aspect-[16/7] md:aspect-[16/6]">
          <img
            src="https://readdy.ai/api/search-image?query=Streetwear%20fashion%20editorial%20scene%20with%20curated%20outfits%20on%20minimalist%20cream%20backdrop%2C%20warm%20natural%20light%2C%20artistic%20filmic%20grain%20texture%2C%20soft%20muted%20colors%2C%20european%20fashion%20magazine%20aesthetic%2C%20organic%20composition%2C%20lifestyle%20photography&width=1400&height=600&seq=cta-fashion-bg&orientation=landscape"
            alt="Fashion lifestyle editorial"
            className="absolute inset-0 w-full h-full object-cover object-center"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/25"></div>
        </div>

        <div className="text-center space-y-3 md:space-y-4 mb-8 md:mb-10">
          <p className="text-xl md:text-3xl font-heading text-foreground-950 leading-snug">
            Compare <strong className="font-bold">GTBuy</strong>{" "}
            <span className="italic font-normal text-foreground-500">vs</span>{" "}
            <strong className="font-bold">Kakobuy</strong>{" "}
            <span className="italic font-normal text-foreground-500">vs</span>{" "}
            <strong className="font-bold">Superbuy</strong>
          </p>
          <p className="text-lg md:text-2xl font-heading text-foreground-700">
            Find the best value in <span className="italic">one click</span>
          </p>
          <p className="text-base md:text-xl font-heading text-foreground-600">
            Start your <span className="italic">smart journey</span> today
          </p>
        </div>

        <div className="text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-block whitespace-nowrap px-10 py-4 bg-primary-500 text-white font-label font-semibold text-sm md:text-base rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            Visit Kaspreadsheet Now
          </a>
        </div>
      </div>
    </section>
  );
}